import { createUseStyles } from 'react-jss';

import { MENU_COLLAPSE_BREAKPOINT } from '../../../common';
import { ITheme } from '../../../../styles/theme';
import { mediaQuery } from '../../../../styles/helpers';

const HEADER_HEIGHT = 80;
const MOBILE_HEADER_HEIGHT = 59;
const DESKTOP_CMP_PADDING = 32;
const MOBILE_CMP_PADDING = 16;

export default createUseStyles<
  string,
  {
    cmpHeight: number;
    textHeight: number;
    hasMobileDescription: boolean;
    hasFilterButton: boolean;
  }
>(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-5)',
      textAlign: 'center',
      zIndex: 100,
      position: 'sticky',

      top: ({ textHeight }) => HEADER_HEIGHT - textHeight - DESKTOP_CMP_PADDING,

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        top: ({ textHeight }) => MOBILE_HEADER_HEIGHT - textHeight - MOBILE_CMP_PADDING,
        padding: [0, 16, 16, 16],
      },
    },
    container: {
      backgroundColor: 'var(--x-bg-1)',
      boxShadow: '0px 1px 4px var(--x-shadow-card)',
      borderRadius: 16,
      padding: DESKTOP_CMP_PADDING,

      [mediaQuery(breakpoints.mobile)]: {
        padding: MOBILE_CMP_PADDING,
      },
    },

    imgContainer: {
      maxWidth: '100%',
      marginTop: -16,
    },
    img: {
      maxWidth: '50%',
    },
    primaryText: {
      color: 'var(--x-accent-2-2)',
      fontSize: 42,
      fontWeight: 500,
      lineHeight: '50px',
      marginBottom: 16,

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },

    textContainer: {
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: ({ hasMobileDescription }) => (hasMobileDescription ? 16 : 0),
      },
    },

    secondaryText: ({ hasMobileDescription }) => ({
      color: 'var(--x-text-color-2)',
      fontSize: 16,
      lineHeight: '24px',

      [mediaQuery(breakpoints.tablet)]: {
        display: hasMobileDescription ? 'initial' : 'none',
      },
    }),
    inputContainer: {
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
      textAlign: 'left',
      marginTop: 24,

      [mediaQuery(breakpoints.tablet)]: {
        marginTop: 0,
      },
    },
    input: {
      border: '2px solid var(--x-border-4)',
      borderRadius: 12,
      color: 'var(--x-text-color-1)',
      fontSize: 20,
      lineHeight: '28px',
      padding: [12, 44, 12, 54],
      width: '100%',

      '&:focus': {
        borderColor: 'var(--x-accent-2-1)',
      },
      '&::placeholder': {
        color: 'var(--x-text-color-2)',
      },
      '&:hover': {
        background: '#F8F8F8',
        border: '2px solid var(--x-border-4)',
      },

      '&::selection': {
        backgroundColor: 'var(--x-text-color-2)',
        color: 'var(--x-bg-1)',
      },

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        fontSize: 14,
        lineHeight: '20px',
        padding: [12, 34, 12, 46],
        width: ({ hasFilterButton }) => (hasFilterButton ? 'calc(100% - 40px)' : '100%'),
      },
    },
    inputNoSearch: {
      paddingInlineStart: 14,
    },
    magnifierIcon: {
      fill: 'var(--x-black)',
      left: 20,
      position: 'absolute',
      top: 'calc(50% - 12px)',

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        left: 14,
      },
    },

    filterContainer: {
      display: 'none',

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        display: 'inline-block',
        marginLeft: 15,
      },
    },
    filterButton: {
      background: 'var(--x-bg-1)',
      border: 0,
      cursor: 'pointer',
    },
    filterIcon: {
      fill: 'var(--x-black)',
    },
    closeIconContainer: {
      cursor: 'pointer',
      position: 'absolute',
      right: 20,
      top: 'calc(50% - 12px)',

      [mediaQuery(breakpoints.mobile)]: {
        right: 10,
      },
    },
    closeIcon: {
      fill: 'var(--x-text-color-6)',
    },
  }),
  { name: 'SectionWithStickyInput' },
);
